import script from "./AreaHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaHeader.vue?vue&type=script&setup=true&lang=js"

import "./AreaHeader.vue?vue&type=style&index=0&id=45520a22&lang=scss"

const __exports__ = script;

export default __exports__